import { useEffect } from 'react'
import { fetchFlightCampaignDeals } from 'actions/FlightActions'
import { useAppSelector, useAppDispatch } from 'hooks/reduxHooks'

const emptyList: App.ApiCallState<{ data: Array<App.FlightDeal> }> = {
  fetching: true,
  data: [],
  error: undefined,
}

type Result = [
  deals: Array<App.FlightDeal>,
  loading: boolean,
]

export function useFlightCampaignDeals(id: string): Result {
  const dispatch = useAppDispatch()

  useEffect(() => {
    dispatch(fetchFlightCampaignDeals(id))
  }, [id, dispatch])

  const deals = useAppSelector(state => state.flights.campaignDeals[id] ?? emptyList)

  return [deals.data, !!deals.fetching]
}
